import React, { useCallback, useEffect, useState } from 'react';
import imgurl from '../assests/images/imgurl'
import { Typography } from '@mui/material';
import { Link } from "react-router-dom";
import i18next from 'i18next';
import { useSelector } from 'react-redux';


function Footer() {
    const [isMobile, setIsMobile] = useState(false);
    const locale = useSelector((state) => state.language.langData)

    const proceedToNxtPrivacy = useCallback(() => {
        window.open(`https://aloxa.ai/privacy-policy?lang=${locale}`, "_blank");
      }, [locale]);

    const proceedToNxtService = useCallback(() => {
        window.open(`https://aloxa.ai/terms-of-service?lang=${locale}`, "_blank");
      }, [locale]);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  return (
    <div className={!isMobile ? 'footerSection' : 'footerSection'}>

        <div className='footerDetails'>

           <div className='logoAddress'>
           
           <div className='footerLogo'>
            <img src={imgurl.hairlossaiLogo}></img>
           </div>

           <div className='footerAddress'>
            <Typography>Centa  Biotech SL, Alameda Principal 11, 29001 Malaga, Spain.</Typography>
            {/* <Typography>29001 Malaga, Spain. </Typography> */}
           </div>

        
           </div>
           <div className="mt-5px footerDiv">
           <div>
            <Typography className='footerName rightsText'>{i18next.t("©2025 Alopexia. All rights reserved.")}</Typography>
            </div>

            <div className='footerLinks'>
              <div>
                <a href="https://alopexia.com/privacy-policy/" className="linkName">
                <Typography className="footerName">• {i18next.t("Privacy Policy")}</Typography>
              </a>
              </div>
              <div className='text-left'>
                <a href="https://alopexia.com/terms-of-service/" className="linkName">
                <Typography className="footerName">• {i18next.t("Terms of Service")}</Typography>
              </a>
              </div>
              <div>
                <a href="https://alopexia.com/contact-information/" className="linkName">
                <Typography className="footerName">• {i18next.t("Contact Information")}</Typography>
              </a>
              </div>
              {/* <div>
              <Link to="https://alopexia.com/policies/refund-policy" className="linkName">
              <Typography className="footerName">• {i18next.t("Refund Policy")}</Typography>
              </Link>
              </div> */}
              {/* <div>
              <Link to="" className="linkName">
              <Typography className="footerName">• {i18next.t("Cookie Preferences")}</Typography>
              </Link>
              </div> */}
              {/* <div>
              <Link to="/feedback" className="linkName">
              <Typography className="footerName">• {i18next.t("Feedback Form")}</Typography>
              </Link>
              </div> */}
            </div>
        {/* <Grid item xs={6}></Grid> */}

        
            {/* <div className='centabioLink'>
              <a href="https://www.centabio.com/" target='_blank'>www.centabio.com</a>
            </div> */}
           </div>

        </div>
      
    </div>
  )
}

export default Footer
